import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import Modal from 'jl-design-system/components/modal/Modal';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { submitForm } from 'jl-design-system/redux/actions/form/formActions';
// redux
import { connect } from 'react-redux';
import { go } from 'connected-react-router';
import {
  handleRemoveItem,
  hideItemRemoveOverlay,
  showItemRemoveOverlay,
  updateItemQuantity,
} from '../../redux/actions/edit-basket/editBasketActions';
// components
import EditBasketItem from '../edit-basket-item/EditBasketItem';
import { ITEM_QUANTITY_FORM } from '../../utils/form/configs/itemQuantity';
// styles
import styles from './edit-basket-modal.scss';
import editBasketConstants from '../../constants/editBasketConstants';
import appConstants from '../../constants/appConstants';

export class EditBasketModal extends PureComponent {

  static propTypes = {
    basketTotal: PropTypes.string,
    currentItem: PropTypes.string,
    deliveries: PropTypes.arrayOf(PropTypes.object).isRequired,
    editBasketItemOutOfStockOverlayIds: PropTypes.arrayOf(PropTypes.string),
    editBasketItemRemoveOverlayIds: PropTypes.arrayOf(PropTypes.string),
    editBasketItemUpdateActiveIds: PropTypes.arrayOf(PropTypes.string),
    editBasketRemoveItemApiCallActiveIds: PropTypes.arrayOf(PropTypes.string),
    go: PropTypes.func,
    handleRemoveItem: PropTypes.func,
    hideItemRemoveOverlay: PropTypes.func,
    isProcessing: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    showItemRemoveOverlay: PropTypes.func,
    showModal: PropTypes.bool,
    submitForm: PropTypes.func,
    updateItemQuantity: PropTypes.func,
  };

  static defaultProps = {
    basketTotal: '',
    currentItem: '',
    deliveries: [],
    editBasketItemOutOfStockOverlayIds: [],
    editBasketItemRemoveOverlayIds: [],
    editBasketItemUpdateActiveIds: [],
    editBasketRemoveItemApiCallActiveIds: [],
    getItemsApiCallActive: false,
    go: window.defaultFunc,
    handleRemoveItem: window.defaultFunc,
    hideItemRemoveOverlay: window.defaultFunc,
    isProcessing: false,
    items: [],
    putItemQuantityApiCallActive: false,
    removeBasketItemsApiCallActive: false,
    showItemRemoveOverlay: window.defaultFunc,
    showModal: false,
    submitForm: window.defaultFunc,
    updateItemQuantity: window.defaultFunc,
  };

  static getOverlayType({
    itemId,
    editBasketItemRemoveOverlayIds,
    editBasketItemOutOfStockOverlayIds,
    parentHasRemovalOverlay,
  }) {
    if (!parentHasRemovalOverlay) {
      if (editBasketItemRemoveOverlayIds.indexOf(itemId) !== -1) {
        return editBasketConstants.REMOVE_ITEM;
      }
      if (editBasketItemOutOfStockOverlayIds.indexOf(itemId) !== -1) {
        return editBasketConstants.OUT_OF_STOCK_ITEM;
      }
    }
    return '';
  }

  componentDidUpdate() {
    const currentItem = this.props.currentItem;
    const focusedElement = document.querySelector(`form[form="${ITEM_QUANTITY_FORM}-${currentItem}"] select`);
    if (focusedElement) {
      setTimeout(() => { focusedElement.focus(); }, 0);
    }
  }

  onClose = () => {
    const { go, isProcessing } = this.props;
    if (!isProcessing) {
      go(-1);
    }
  };

  getQuantityChangeHandler = formId => () => {
    const { submitForm } = this.props;
    submitForm(formId);
  };

  onFormSubmit = ({ itemId, itemQuantity }) => {
    const { updateItemQuantity } = this.props;
    return updateItemQuantity({
      itemId,
      quantity: itemQuantity,
    });
  };

  renderChildItem = ({
    isProcessing,
    item,
    parentQuantity,
    parentHasRemovalOverlay,
    isOutOfStockOverlayActive,
  }) => {
    const {
      deliveries,
      handleRemoveItem,
      hideItemRemoveOverlay,
      showItemRemoveOverlay,
      editBasketItemUpdateActiveIds,
      editBasketItemRemoveOverlayIds,
      editBasketItemOutOfStockOverlayIds,
      editBasketRemoveItemApiCallActiveIds,
    } = this.props;

    const overlayType = EditBasketModal.getOverlayType({
      itemId: item.id,
      editBasketItemRemoveOverlayIds,
      editBasketItemOutOfStockOverlayIds,
      parentHasRemovalOverlay,
    });
    const isItemUpdating = editBasketItemUpdateActiveIds.indexOf(item.id) !== -1;
    const removeItemApiCallActive = editBasketRemoveItemApiCallActiveIds.indexOf(item.id) !== -1;

    return (
      <EditBasketItem
        key={item.id}
        deliveries={deliveries}
        disabled={isProcessing || isOutOfStockOverlayActive}
        handleQuantityChange={this.getQuantityChangeHandler}
        handleRemoveItem={handleRemoveItem}
        hideItemRemoveOverlay={hideItemRemoveOverlay}
        isChildItem
        isItemUpdating={isItemUpdating}
        isProcessing={isProcessing}
        item={item}
        maxValue={parentQuantity}
        onFormSubmit={this.onFormSubmit}
        overlayType={overlayType}
        removeItemApiCallActive={removeItemApiCallActive}
        showItemRemoveOverlay={showItemRemoveOverlay}
      />
    );
  };

  renderItem = (item, isOutOfStockOverlayActive) => {
    const {
      deliveries,
      items,
      handleRemoveItem,
      hideItemRemoveOverlay,
      showItemRemoveOverlay,
      editBasketItemUpdateActiveIds,
      editBasketItemRemoveOverlayIds,
      editBasketItemOutOfStockOverlayIds,
      editBasketRemoveItemApiCallActiveIds,
      isProcessing,
    } = this.props;

    const lastItemInBasket = items.length === 1;
    const overlayType = EditBasketModal.getOverlayType({
      itemId: item.id,
      editBasketItemRemoveOverlayIds,
      editBasketItemOutOfStockOverlayIds,
    });
    const isItemUpdating = editBasketItemUpdateActiveIds.indexOf(item.id) !== -1;
    const removeItemApiCallActive = editBasketRemoveItemApiCallActiveIds.indexOf(item.id) !== -1;

    return (
      <EditBasketItem
        key={item.id}
        deliveries={deliveries}
        disabled={isProcessing || isOutOfStockOverlayActive}
        handleQuantityChange={this.getQuantityChangeHandler}
        handleRemoveItem={handleRemoveItem}
        hideItemRemoveOverlay={hideItemRemoveOverlay}
        isItemUpdating={isItemUpdating}
        isProcessing={isProcessing}
        item={item}
        lastItemInBasket={lastItemInBasket}
        onFormSubmit={this.onFormSubmit}
        overlayType={overlayType}
        removeItemApiCallActive={removeItemApiCallActive}
        showItemRemoveOverlay={showItemRemoveOverlay}
      >
        {
          (item.childItems || []).map(childItem => this.renderChildItem({
            isProcessing,
            item: childItem,
            parentQuantity: item.quantity,
            parentHasRemovalOverlay: !!overlayType,
            isOutOfStockOverlayActive,
          }))
        }
      </EditBasketItem>
    );
  };

  renderModalContent = () => {
    const {
      basketTotal,
      items,
      editBasketItemOutOfStockOverlayIds,
      isProcessing,
    } = this.props;
    const isOutOfStockOverlayActive = !!editBasketItemOutOfStockOverlayIds.length;

    return (
      <div>
        {
          items.map(item => this.renderItem(item, isOutOfStockOverlayActive))
        }
        <div className={styles.basketTotalContainer} data-test="edit-basket-modal-total-container">
          <span>Basket total</span>
          <span className={styles.basketTotalValue}>{basketTotal}</span>
        </div>
        <PrimaryButton
          className={styles.doneButton}
          data-test="edit-basket-modal-done-button"
          disabled={isProcessing || isOutOfStockOverlayActive}
          onClick={this.onClose}
        >
          Done
        </PrimaryButton>
      </div>
    );
  };

  render() {
    const { showModal, isProcessing } = this.props;

    if (!showModal) {
      return null;
    }

    return (
      <Modal
        className={styles.customModalStyles}
        disableControls={isProcessing}
        forceFullHeight
        header="Basket"
        isOpen
        onClose={this.onClose}
        rootId={appConstants.ROOT}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
      >
        <div
          data-test="edit-basket-modal"
        >
          {this.renderModalContent()}
        </div>

      </Modal>
    );
  }
}

export default connect((state) => {

  const putItemQuantityApiCallActive = state.orderForm.putItemQuantityApiCallActive;
  const getItemsApiCallActive = state.orderForm.getItemsApiCallActive;
  const removeBasketItemsApiCallActive = state.orderForm.removeBasketItemsApiCallActive;

  const isProcessing = (
    putItemQuantityApiCallActive ||
    getItemsApiCallActive ||
    removeBasketItemsApiCallActive
  );

  return {
    basketTotal: state.orderForm.amounts.grandTotal,
    deliveries: state.delivery.deliveries,
    items: state.orderForm.items,
    isProcessing,
    showModal: state.delivery.showEditBasketModal,
    editBasketItemRemoveOverlayIds: state.orderForm.editBasketItemRemoveOverlayIds,
    editBasketItemOutOfStockOverlayIds: state.orderForm.editBasketItemOutOfStockOverlayIds,
    editBasketItemUpdateActiveIds: state.orderForm.editBasketItemUpdateActiveIds,
    editBasketRemoveItemApiCallActiveIds: state.orderForm.editBasketRemoveItemApiCallActiveIds,
    currentItem: state.delivery.currentItemFocus,
  };

}, {
  go,
  handleRemoveItem,
  hideItemRemoveOverlay,
  showItemRemoveOverlay,
  updateItemQuantity,
  submitForm,
})(EditBasketModal);
